import defaultProductLogo from "./svg/default-product-logo.svg";
import defaultGreetingsLogin from "./svg/default-greetings-login.svg";
const Images = {
  defaultProductLogo,
  defaultGreetingsLogin
};
export { Images };